<template>
	<Col>
		<SharedGroupItem
			:group="group"
			:key="group.id"
			:workflow="workflow"
			v-for="group in groups"
			:sharedData="sharedData"
			:usersSharedData="usersSharedData"
			:nestedLevelIndex="nestedLevelIndex"
			:hideVisibilityStatus="hideVisibilityStatus"
		/>
	</Col>
</template>
<script>
import SharedGroupItem from '@/components/dialogs/ShareFeatureDialog/ExistingShareList/SharedGroupItem.vue';
export default {
	name: 'SharedGroups',
	components: { SharedGroupItem },
	props: {
		groups: { type: Array },
		workflow: { type: Object },
		sharedData: { type: Array },
		usersSharedData: { type: Array },
		hideVisibilityStatus: { type: Boolean },
	},
	data() {
		return { nestedLevelIndex: 0 };
	},
};
</script>
<style scoped lang="scss"></style>
